import FinancialCalendarNewItem from './FinancialCalendarNewItem';

export default FinancialCalendarNewItem;
